import * as core from '../../../../../../../core'
import * as testOutcome from '../test-outcome'

export const RESOURCE = {
  payload: {
    description: 'Every test in the run that was not skipped passed',
    enumId: core.dms.models.Enum.Id.from({
      partialId: testOutcome.RESOURCE.payload.partialId,
    }),
    id: 'PASS',
    name: 'Pass',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
